// assets\menu.js
$(document).ready(function () {
  var current_url = window.location.href;

  $('.oc-menu .li-top-item .a-top-link').each(function () {
    var $link = $(this);
    var link = $link.attr('href');
    if (!link || link === '#') return;
  
    var $li = $link.closest('.li-top-item');
    var hasMegaMenu = $li.find('.mega-menu-container').length > 0;
  
    // Пропускаем пункты-триггеры мега-меню с заглушкой href="/" —
    // у них ссылка условная, не должна участвовать в подсветке активности
    if (link === '/' && hasMegaMenu) return;
  
    var linkPath = link.replace(/\/$/, '') || '/';
    var currentPath = window.location.pathname.replace(/\/$/, '') || '/';
  
    if (currentPath === linkPath) {
      $li.addClass('active');
    }
  });

  $('.horizontal-menu .mega-menu-container').each(function () {
    if($(this).hasClass('right')) {
      if($(this).hasClass('full-width')) {
        $(this).closest('li').removeClass().addClass('li-top-item mega-right');
      } else {
        $(this).closest('li').removeClass().addClass('li-top-item right');

        var menu = $('.oc-menu-bar').offset();
        var dropdown = $(this).parent().offset();

        var dropdownRight = $('.oc-menu-bar').outerWidth() - dropdown.left;

        var i = (dropdownRight + $(this).outerWidth()) - ($('.oc-menu-bar').outerWidth());

        if (i > 0) {
          $(this).css('margin-right', '-' + (i) + 'px');
        }
      }
    }

    if($(this).hasClass('left')) {
      if($(this).hasClass('full-width') == false) {
        var menu = $('.oc-menu-bar').offset();
        var dropdown = $(this).parent().offset();

        var i = (dropdown.left + $(this).outerWidth()) - (menu.left + $('.oc-menu-bar').outerWidth());

        if (i > 0) {
          $(this).css('margin-left', '-' + (i + 10) + 'px');
        }
      }
    }
  });

  $('.sub-menu-container').each(function () {
    var total_cols = 0;
    $(this).find('.sub-item2-content').each(function () {
      var cols = parseFloat($(this).data('cols'));
      if(total_cols == 0) {
        $(this).css('clear', 'left');
      }
      total_cols += cols;
      if(total_cols > 12) {
        $(this).css('clear', 'left');
        total_cols = cols;
      }
      if(total_cols == 12) {
        total_cols = 0;
      }
    });
  });

  $('.vertical-menu .oc-menu-bar').click(function () {
    var effect = $(this).closest('.oc-menu').find('.menu-effect').val();
    if(effect == "none") {
      $('.vertical-menu .ul-top-items').toggle();
    }

    if(effect == "fade") {
      $('.vertical-menu .ul-top-items').fadeToggle();
    }

    if(effect == "slide") {
      $('.vertical-menu .ul-top-items').slideToggle();
    }
  });

  $('.a-plus').click(function() {
    var effect = $(this).closest('.oc-menu').find('.menu-effect').val();
    if(effect == "none") {
      $('.li-plus').hide();
      $('.over').show();
    }

    if(effect == "fade") {
      $('.li-plus').fadeOut();
      $('.over').fadeIn();
    }

    if(effect == "slide") {
      $('.li-plus').slideUp();
      $('.over').slideDown();
    }
  });

  $('.a-minus').click(function() {
    var effect = $(this).closest('.oc-menu').find('.menu-effect').val();
    if(effect == "none") {
      $('.over').hide();
      $('.li-plus').show();
    }

    if(effect == "fade") {
      $('.over').fadeOut();
      $('.li-plus').fadeIn();
    }

    if(effect == "slide") {
      $('.over').slideUp();
      $('.li-plus').slideDown();
    }
  });

function syncMobileMenuViewport(force) {
  if (force !== true && !document.querySelector('.mobile-menu.menu-open')) return;
  var vv = window.visualViewport;
  var h = Math.round(vv ? vv.height : window.innerHeight);
  var t = Math.round(vv ? vv.offsetTop : 0);
  var root = document.documentElement;
  root.style.setProperty('--mobile-menu-vh', h + 'px');
  root.style.setProperty('--mobile-menu-top', t + 'px');
}

syncMobileMenuViewport(true);
$(window).on('resize.mobileMenuVh orientationchange.mobileMenuVh', syncMobileMenuViewport);
if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', syncMobileMenuViewport);
  window.visualViewport.addEventListener('scroll', syncMobileMenuViewport);
}

function closeMobileMenu($menu) {
  $menu = $menu && $menu.length ? $menu : $('.mobile-menu.menu-open');
  if (!$menu.length) return;

  $menu.removeClass('menu-open');
  $('body').removeClass('mobile-menu-open-lock');
  $menu.find('.ul-top-items').css('display', '');
  $menu.find('.li-top-item.expand').removeClass('expand');
  $menu.find('.sub-menu-container, .flyout-third-items').hide();
  if (typeof restoreBoxCartFromMenu === 'function') {
    restoreBoxCartFromMenu();
  }
}

$(window).on('resize.mobileMenuClose', function () {
  if (window.innerWidth < 992) return;
  closeMobileMenu();
});

$('.mobile-menu .oc-menu-bar .right').click(function () {
  var $menu = $(this).closest('.mobile-menu');
  var effect = $menu.find('.menu-effect').val();
  var opening = !$menu.hasClass('menu-open');

  if (opening) {
    $menu.addClass('menu-open');
    syncMobileMenuViewport(true);
    $('body').addClass('mobile-menu-open-lock');
    if (typeof relocateBoxCartIntoMenu === 'function') {
      relocateBoxCartIntoMenu($menu);
    }
    if (effect == "fade") {
      $menu.find('.ul-top-items').hide().fadeIn();
    } else if (effect == "slide") {
      $menu.find('.ul-top-items').hide().slideDown();
    } else {
      $menu.find('.ul-top-items').show();
    }
  } else {
    closeMobileMenu($menu);
  }
});

  $('.oc-menu').each(function () {
    var $mobile = $(this).hasClass('mobile-menu');
    var effect = $(this).find('.menu-effect').val();

    if($mobile) {
      $(this).find('.li-top-item .top-click-show').click(function () {
        var flag = $(this).closest('.li-top-item').hasClass('expand');

        if(flag) {
          $(this).closest('.li-top-item').removeClass('expand');

          if (effect == "none") {
            $(this).closest('.li-top-item').find('.sub-menu-container').hide();
          }

          if (effect == "fade") {
            $(this).closest('.li-top-item').find('.sub-menu-container').fadeOut('slow');
          }

          if (effect == "slide") {
            $(this).closest('.li-top-item').find('.sub-menu-container').slideUp();
          }
        } else {
          $('.li-top-item').removeClass('expand');

          $(this).closest('.li-top-item').addClass('expand');

          if (effect == "none") {
            $('.mobile-menu .sub-menu-container').hide();
            $(this).closest('.li-top-item').find('.sub-menu-container').show();
          }

          if (effect == "fade") {
            $('.mobile-menu .sub-menu-container').fadeOut('slow');
            $(this).closest('.li-top-item').find('.sub-menu-container').fadeIn('slow');
          }

          if (effect == "slide") {
            $('.mobile-menu .sub-menu-container').slideUp();
            $(this).closest('.li-top-item').find('.sub-menu-container').slideDown('slow');
          }
        }
      });

      $(this).find('.li-second-items .second-click-show').click(function () {
        var flag = $(this).closest('.li-second-items').hasClass('expand');

        if(flag) {

          $(this).closest('.li-second-items').removeClass('expand');

          if (effect == "none") {
            $(this).closest('.li-second-items').find('.flyout-third-items').hide();
          }

          if (effect == "fade") {
            $(this).closest('.li-second-items').find('.flyout-third-items').fadeOut('slow');
          }

          if (effect == "slide") {
            $(this).closest('.li-second-items').find('.flyout-third-items').slideUp();
          }
        } else {
          $('.li-second-items').removeClass('expand');

          $(this).closest('.li-second-items').addClass('expand');

          if (effect == "none") {
            $('.mobile-menu .flyout-third-items').hide();
            $(this).closest('.li-second-items').find('.flyout-third-items').show();
          }

          if (effect == "fade") {
            $('.mobile-menu .flyout-third-items').fadeOut('slow');
            $(this).closest('.li-second-items').find('.flyout-third-items').fadeIn('slow');
          }

          if (effect == "slide") {
            $('.mobile-menu .flyout-third-items').slideUp();
            $(this).closest('.li-second-items').find('.flyout-third-items').slideDown('slow');
          }
        }
      });
    } else {
  var $menu = $(this);
  var megaMenuCloseTimer;
  var megaMenuHideTimer;
  var MEGA_HIDE_MS = 500;

function scheduleHideClosed() {
  clearTimeout(megaMenuHideTimer);
  megaMenuHideTimer = setTimeout(function () {
    $menu.find('.sub-menu-container').not('.menu-slide-in').hide();
  }, MEGA_HIDE_MS);
}

function closeSubMenu($li, effect) {
  if (effect == "none") {
    $li.find('.sub-menu-container').hide();
  }
  if (effect == "fade") {
    $li.find('.sub-menu-container').stop(true, true).fadeOut('slow');
  }
  if (effect == "slide") {
    $li.find('.sub-menu-container').removeClass('menu-slide-in');
    scheduleHideClosed();
  }
}

  $(this).find('.li-top-item').hover(
    function () {
      clearTimeout(megaMenuCloseTimer);
      var effect = $(this).closest('.oc-menu').find('.menu-effect').val();

      if (effect == "none") {
        $('.sub-menu-container').hide();
        $(this).find('.sub-menu-container').show();
      }

      if (effect == "fade") {
        $('.sub-menu-container').stop(true, true).fadeOut('slow');
        $(this).find('.sub-menu-container').stop(true, true).fadeIn('slow');
      }

       if (effect == "slide") {
        var $current = $(this).find('.sub-menu-container');
        $menu.find('.sub-menu-container').not($current).removeClass('menu-slide-in');
        scheduleHideClosed();
        if ($current.hasClass('menu-slide-in') || $current.is(':visible')) {
          $current.addClass('menu-slide-in');
        } else {
          $current.stop(true, true).show();
          requestAnimationFrame(function () {
            $current.addClass('menu-slide-in');
          });
        }
      }
    },

    function () {
      var $li = $(this);
      var effect = $li.closest('.oc-menu').find('.menu-effect').val();

      megaMenuCloseTimer = setTimeout(function () {
        closeSubMenu($li, effect);
      }, 100);
    }
  );

  $(this).find('.li-top-item .sub-menu-container').hover(
    function () {
      if (!$(this).hasClass('menu-slide-in')) return;
      clearTimeout(megaMenuCloseTimer);
      $(this).stop(true, true);
    },
    function () {
      var $container = $(this);
      if (!$container.hasClass('menu-slide-in')) return;
      var $li = $container.closest('.li-top-item');
      var effect = $li.closest('.oc-menu').find('.menu-effect').val();

      megaMenuCloseTimer = setTimeout(function () {
        closeSubMenu($li, effect);
      }, 100);
    }
  );
      

      $(this).find('.li-second-items').hover(
        function () {
          var effect = $(this).closest('.oc-menu').find('.menu-effect').val();

          if (effect == "none") {
            $('.flyout-third-items').hide();
            $(this).find('.flyout-third-items').show();
          }

          if (effect == "fade") {
            $('.flyout-third-items').fadeOut('slow');
            $(this).find('.flyout-third-items').fadeIn('slow');
          }

          if (effect == "slide") {
            $('.flyout-third-items').slideUp();
            $(this).find('.flyout-third-items').slideDown('slow');
          }
        },

        function () {
          var effect = $(this).closest('.oc-menu').find('.menu-effect').val();

          if (effect == "none") {
            $(this).find('.flyout-third-items').hide();
          }

          if (effect == "fade") {
            $(this).find('.flyout-third-items').fadeOut('slow');
          }

          if (effect == "slide") {
            $(this).find('.flyout-third-items').slideUp();
          }
        }
      );

      $(window).off('scroll.megaMenuClose').on('scroll.megaMenuClose', function () {
        var $open = $menu.find('.sub-menu-container.menu-slide-in');
        if (!$open.length) return;
        clearTimeout(megaMenuCloseTimer);
        $open.removeClass('menu-slide-in');
        $menu.find('.flyout-third-items').hide();
        if (!$('header .fix').hasClass('fix-header')) {
          $open.hide();
        } else {
          scheduleHideClosed();
        }
      });
    }
  });

  if($('.oc-menu').hasClass('mobile-menu')) {

  } else {

  }
})

// Burger bars on whole device pixels. At rest the burger is one bar plus three
// box-shadow copies (menu.css.liquid); with the copy step and the thickness
// rounded to whole device pixels every copy lands on the same sub-pixel phase
// as the bar itself, so all four look alike at DPR 2.625 / 2.75 / 1.25 too
// (3px / 5px are 7.875 / 13.125 device px there). The CSS keeps 3/5/18px when
// JS is off.
;(function () {
  var lastDpr = 0;
  function snapBurger() {
    var dpr = window.devicePixelRatio || 1;
    if (dpr === lastDpr) return;
    var right = document.querySelector('.mobile-menu .oc-menu-bar .right');
    if (!right) return;
    lastDpr = dpr;
    var px = function (v) { return Math.round(v * dpr) / dpr + 'px'; };
    right.style.setProperty('--burger-t', px(3));
    right.style.setProperty('--burger-s', px(5));
    right.style.setProperty('--burger-w', px(18));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', snapBurger);
  else snapBurger();
  // DPR changes with browser zoom or moving the window to another screen
  window.addEventListener('resize', snapBurger);
})();
